(function($){
    $('[data-enlargeable]').addClass('img-enlargeable').on("click",function() {
        var xAxis = this.getBoundingClientRect().width;
        var yAxis = this.getBoundingClientRect().height;
        
        var src = $(this).attr('zoomed-src');
        var modal;

        var favorX = { 
            width: window.innerWidth <= 640 ? '90%' : '75%',
            height: 'auto'
        }; 
        var favorY = { 
            width: 'auto',
            height: '100%',
            maxHeight: '85%'
        }; 

        // yAxis * 1.25 added to the equation to avoid misjudgement on small height x width differences.
        var cssOption = xAxis >= (yAxis * 1.25) ? favorX : favorY;

        if (window.innerHeight > window.innerWidth) {
            cssOption = favorX;
        } 

        var submodal = $('<img>').css(cssOption);

        submodal.attr("src", src); 

        function removeModal() {
            modal.remove();
            $('body').off('keyup.modal-close');
        }
        modal = $('<div>').css({
            backgroundColor: 'rgba(0,0,0,0.5)',
            position: 'fixed',
            zIndex: '10000',
            top: '0',
            bottom: '0',
            left: '0',
            right: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'zoom-out'
        });

        submodal.appendTo(modal);
        
        modal.on("click",function() {
            removeModal();
        }).appendTo('body');

        //handling ESC
        $('body').on('keyup.modal-close', function(e) {
            if (e.key === 'Escape') {
                removeModal();
            }
        });
    });

})(jQuery);